"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualHomeDocumentListModal = exports.HomeDocVersionEnum = void 0;
exports.getHomeDOIDocumentVersion = getHomeDOIDocumentVersion;
exports.getHomeDocumentVersion = getHomeDocumentVersion;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var services_1 = require("@falcon/services");
var core_1 = require("@athena-portal/core");
var commonFunctions_1 = require("../../../commonFunctions");
var PRIVACY_NOTICE_URL = services_1.resourcesHelper.PRIVACY_NOTICE_URL, LEGAL_NOTICE_URL = services_1.resourcesHelper.LEGAL_NOTICE_URL;
var HomeDocVersionEnum;
(function (HomeDocVersionEnum) {
    HomeDocVersionEnum["V1"] = "v1";
    HomeDocVersionEnum["V2"] = "v2";
    HomeDocVersionEnum["V3"] = "v3";
    HomeDocVersionEnum["V4"] = "v4";
    HomeDocVersionEnum["V5"] = "v5";
})(HomeDocVersionEnum || (exports.HomeDocVersionEnum = HomeDocVersionEnum = {}));
var latestDocumentsEffectiveDate = (_a = process.env.REACT_APP_LATEST_DOCUMENTS_EFFECTIVE_DATE) !== null && _a !== void 0 ? _a : "2026-04-14";
// versions and dates when it starts, newest first
var documentVersionDates = [
    { version: HomeDocVersionEnum.V5, date: new Date(latestDocumentsEffectiveDate) },
    { version: HomeDocVersionEnum.V4, date: new Date("2026-03-19") },
    { version: HomeDocVersionEnum.V3, date: new Date("2025-09-22") },
    { version: HomeDocVersionEnum.V2, date: new Date("1980-01-01") },
    { version: HomeDocVersionEnum.V1, date: new Date("1970-01-01") }
];
// versions and dates when it starts, newest first
var DOIVersionDates = [
    { version: HomeDocVersionEnum.V4, date: new Date("2026-07-21") },
    { version: HomeDocVersionEnum.V3, date: new Date("2025-09-22") },
    { version: HomeDocVersionEnum.V2, date: new Date("2024-09-12") },
    { version: HomeDocVersionEnum.V1, date: new Date("1970-01-01") }
];
var AnnualHomeDocumentListModal = /** @class */ (function (_super) {
    __extends(AnnualHomeDocumentListModal, _super);
    function AnnualHomeDocumentListModal(props) {
        var _this = _super.call(this, props) || this;
        _this.filterDocumentsByAddon = function (document, annualHomeFixedAddons) {
            var tier = _this.props.coverTier;
            return (tier === "GOLD" ||
                !annualHomeFixedAddons ||
                !document.addon ||
                (annualHomeFixedAddons && (annualHomeFixedAddons === null || annualHomeFixedAddons === void 0 ? void 0 : annualHomeFixedAddons[document.addon])));
        };
        _this.renderPrivacyNoticeLink = function () {
            var documentName = services_1.resourcesHelper.THEME === "Allianz" ? "Privacy and Legal Notice" : "Privacy Notice";
            return ((0, jsx_runtime_1.jsx)("li", { className: "media mt-0", children: (0, jsx_runtime_1.jsxs)("a", { className: "document-download-link no-underline", href: PRIVACY_NOTICE_URL, target: "_blank", id: "PLN-privacy", children: [(0, jsx_runtime_1.jsx)("img", { className: "pdf-icon active-icon", alt: "pdf document icon", src: "/".concat(services_1.resourcesHelper.THEME, "/img/pdf-icon.png") }), (0, jsx_runtime_1.jsxs)("h5", { className: "document-name d-flex document-link-text", children: [documentName, " | ", services_1.resourcesHelper.THEME, " Insurance"] })] }) }, "PLN-privacy"));
        };
        _this.renderLegalNoticeLink = function () {
            return ((0, jsx_runtime_1.jsx)("li", { className: "media mt-0", children: (0, jsx_runtime_1.jsxs)("a", { className: "document-download-link no-underline", href: LEGAL_NOTICE_URL, target: "_blank", id: "PLN-legal", children: [(0, jsx_runtime_1.jsx)("img", { className: "pdf-icon active-icon", alt: "pdf document icon", src: "/".concat(services_1.resourcesHelper.THEME, "/img/pdf-icon.png") }), (0, jsx_runtime_1.jsxs)("h5", { className: "document-name d-flex document-link-text", children: ["Legal Notice | ", services_1.resourcesHelper.THEME, " Insurance"] })] }) }, "PLN-legal"));
        };
        _this.renderPLNLinks = function () {
            return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [_this.renderPrivacyNoticeLink(), services_1.resourcesHelper.THEME === 'Britannia' && _this.renderLegalNoticeLink()] }));
        };
        return _this;
    }
    AnnualHomeDocumentListModal.prototype.componentDidMount = function () {
        var _this = this;
        var documents = this.getDocuments();
        documents.forEach(function (doc) {
            _this.baseRequestService.getDocumentSize(doc.path).subscribe(function (response) {
                doc.size = (0, commonFunctions_1.formatFileSize)(response.xhr.getResponseHeader('content-length'));
                _this.setState({ documents: documents });
            });
        });
        this.setState({ documents: documents });
    };
    AnnualHomeDocumentListModal.prototype.render = function () {
        var _this = this;
        var _a;
        if (this.state) {
            var documentsToRender = this.state.documents
                .filter(function (d) { return _this.filterDocumentsByAddon(d, _this.props.annualHomeFixedAddons); }).map(function (document, i) { return ((0, jsx_runtime_1.jsxs)("li", { className: "media", children: [(0, jsx_runtime_1.jsx)("img", { className: "mr-2 document-icon", alt: "document-icon", src: "/".concat(services_1.resourcesHelper.THEME, "/img/pdf-icon.png") }), (0, jsx_runtime_1.jsx)("div", { className: "media-body", children: document.title ?
                            ((0, jsx_runtime_1.jsx)("h5", { children: (0, jsx_runtime_1.jsxs)("a", { className: "no-underline", href: document.path, download: document.filename.replace(/([A-Z])/g, ' $1').trim(), id: _this.trimFileExtension(document.filename), "aria-label": "".concat(document.title), children: [document.title, " (PDF, ", document.size, ")"] }) })) : "" })] }, document.filename + i)); });
            documentsToRender.push(this.renderPLNLinks());
            return this.props.withTitle ? ((0, jsx_runtime_1.jsxs)("div", { id: "policyDocuments", className: "documents-widget mt-0 documents-output-widget", children: [(0, jsx_runtime_1.jsx)("h2", { className: "font-family-base font-weight-semi-bold text-blue-2 fs-18", children: (_a = this.props.title) !== null && _a !== void 0 ? _a : "Documents" }), (0, jsx_runtime_1.jsx)("ul", { className: "list-unstyled documents-section", children: documentsToRender })] })) : ((0, jsx_runtime_1.jsx)("ul", { className: "list-unstyled documents-section", children: documentsToRender }));
        }
        else {
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        }
    };
    AnnualHomeDocumentListModal.prototype.getDocuments = function () {
        var doiDocumentVersion = getHomeDOIDocumentVersion(this.props.policyDate);
        var documentVersion = getHomeDocumentVersion(this.props.policyDate);
        var tier = this.props.coverTier.charAt(0) + this.props.coverTier.slice(1).toLowerCase();
        var newDocumentWording = this.getNewDocumentWording(documentVersion);
        var newDocumentWordingFilePath = newDocumentWording.trim();
        var homeEmergencyDocument;
        if (this.props.addedHEDate && this.props.addedHEDate > this.props.policyDate) {
            var homeEmergencyDocumentVersion = getHomeDocumentVersion(this.props.addedHEDate);
            homeEmergencyDocument = this.getHomeEmergencyDocument(homeEmergencyDocumentVersion);
        }
        else {
            homeEmergencyDocument = this.getHomeEmergencyDocument(documentVersion);
        }
        var homeLegalExpensesDocument;
        if (this.props.addedHLEDate && this.props.addedHLEDate > this.props.policyDate) {
            var homeLegalExpensesDocumentVersion = getHomeDocumentVersion(this.props.addedHLEDate);
            homeLegalExpensesDocument = this.getHomeLegalExpensesDocument(homeLegalExpensesDocumentVersion);
        }
        else {
            homeLegalExpensesDocument = this.getHomeLegalExpensesDocument(documentVersion);
        }
        if (tier) {
            return [
                {
                    title: "Allianz".concat(newDocumentWording, " Home Insurance Document of Insurance"),
                    path: "/resources/documents/LV_Allianz_Annual_Home/".concat(doiDocumentVersion, "/LV_Allianz_Home_DOI.pdf"),
                    filename: "Allianz".concat(newDocumentWordingFilePath, "HomeDocumentInsurance.pdf"),
                    size: ""
                },
                {
                    title: "Allianz".concat(newDocumentWording + " " + tier, " Home Insurance Product Information Document"),
                    path: "/resources/documents/LV_Allianz_Annual_Home/".concat(documentVersion, "/LV_Allianz_Home_IPID_").concat(tier.toUpperCase(), ".pdf"),
                    filename: "Allianz".concat(newDocumentWordingFilePath + tier, "HomeInsuranceProductInformationDocument.pdf"),
                    size: ""
                },
                homeEmergencyDocument,
                homeLegalExpensesDocument
            ];
        }
        else {
            return [];
        }
    };
    AnnualHomeDocumentListModal.prototype.trimFileExtension = function (filename) {
        return filename.substring(0, filename.lastIndexOf('.'));
    };
    AnnualHomeDocumentListModal.prototype.getHomeEmergencyDocument = function (documentVersion) {
        var newDocumentWording = this.getNewDocumentWording(documentVersion);
        var newDocumentWordingFilePath = newDocumentWording.trim();
        return {
            title: "Allianz".concat(newDocumentWording, " Home Emergency Leaflet"),
            path: "/resources/documents/LV_Allianz_Annual_Home/".concat(documentVersion, "/LV_Allianz_Home_Emergency_Leaflet.pdf"),
            filename: "Allianz".concat(newDocumentWordingFilePath, "HomeEmergencyLeaflet.pdf"),
            size: "",
            addon: "homeEmergency"
        };
    };
    AnnualHomeDocumentListModal.prototype.getHomeLegalExpensesDocument = function (documentVersion) {
        var newDocumentWording = this.getNewDocumentWording(documentVersion);
        var newDocumentWordingFilePath = newDocumentWording.trim();
        return {
            title: "Allianz".concat(newDocumentWording, " Home Legal Expenses Leaflet"),
            path: "/resources/documents/LV_Allianz_Annual_Home/".concat(documentVersion, "/LV_Allianz_Home_Legal_Expenses_Leaflet.pdf"),
            filename: "Allianz".concat(newDocumentWordingFilePath, "HomeLegalExpensesLeaflet.pdf"),
            size: "",
            addon: "homeLegalExpenses"
        };
    };
    AnnualHomeDocumentListModal.prototype.getNewDocumentWording = function (documentVersion) {
        return documentVersion !== HomeDocVersionEnum.V1 && documentVersion !== HomeDocVersionEnum.V2 ? " Online" : "";
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.BaseRequestService),
        __metadata("design:type", Object)
    ], AnnualHomeDocumentListModal.prototype, "baseRequestService", void 0);
    return AnnualHomeDocumentListModal;
}(React.Component));
exports.AnnualHomeDocumentListModal = AnnualHomeDocumentListModal;
function getHomeDOIDocumentVersion(startDate) {
    var latestDOIVersionForDate = DOIVersionDates.find(function (vd) { return startDate >= vd.date; });
    return latestDOIVersionForDate ?
        latestDOIVersionForDate.version : DOIVersionDates[0].version;
}
function getHomeDocumentVersion(startDate) {
    var latestOtherDocumentVersionForDate = documentVersionDates.find(function (vd) { return startDate >= vd.date; });
    return latestOtherDocumentVersionForDate ?
        latestOtherDocumentVersionForDate.version : documentVersionDates[0].version;
}
//# sourceMappingURL=AnnualHomeDocumentListModal.js.map